import React from 'react';
import { motion } from 'framer-motion';
import { images } from '../../data/images';
import { useLanguage } from '../../contexts/LanguageContext';
import { organiserSteps, performerSteps } from '../../data/landing';
import { rise, spring, stagger } from '../../utils/motion';
export function TwoSides() {
  const {
    t
  } = useLanguage();
  return <section id="how" aria-labelledby="how-title" className="scroll-mt-24 border-t border-line" data-id="element-436" data-mp="1tx0aj3942hol">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-28" data-id="element-437" data-mp="166wa14r7yy1t">
        <h2 id="how-title" className="max-w-[16ch] text-[36px] font-bold leading-[1.05] tracking-[-0.015em] lg:text-[56px]" data-id="element-438" data-mp="118l0yw8r0rkn">
          {t('how.title')}
        </h2>
        <div className="mt-14 grid gap-14 lg:grid-cols-2 lg:gap-16" data-id="element-439" data-mp="1b5qs24hd4ikv">
          <Side id="performers" title={t('how.performers')} image={images.acoustic} steps={performerSteps} data-id="element-440" data-mp="1b4fqmbbe3mwx" />
          <Side id="organisers" title={t('how.organisers')} image={images.rooftop} steps={organiserSteps} data-id="element-441" data-mp="2qokcul3r4v3z" />
        </div>
      </div>
    </section>;
}
interface SideProps {
  id: string;
  title: string;
  image: string;
  steps: {
    title: string;
    body: string;
  }[];
}
function Side({
  id,
  title,
  image,
  steps
}: SideProps) {
  return <motion.div id={id} className="scroll-mt-24" variants={stagger} initial="hidden" whileInView="show" viewport={{
    once: true,
    margin: '-15% 0px'
  }} data-id="element-442" data-mp="2jqw0j2vxakiy">
      <motion.img variants={{
      hidden: {
        opacity: 0,
        y: 20
      },
      show: {
        opacity: 1,
        y: 0,
        transition: spring.heavy
      }
    }} src={image} alt="" className="aspect-[16/10] w-full rounded-lg object-cover" data-id="element-443" data-mp="2oppailc03ted" />
      <motion.h3 variants={rise} className="mt-8 text-[26px] font-bold tracking-[-0.01em] lg:text-[32px]" data-id="element-444" data-mp="21163e94otmnv">
        {title}
      </motion.h3>
      <ol className="mt-6" data-id="element-445" data-mp="25sedz8hr7e2m">
        {steps.map((s, i) => <motion.li key={s.title} variants={rise} className="relative flex gap-5 pb-7 last:pb-0" data-id="element-446" data-mp="18cigya87cr8q" data-mpi={i}>
            {i < steps.length - 1 && <span className="absolute left-[19px] top-11 h-[calc(100%-44px)] w-0.5 bg-line" aria-hidden="true" data-id="element-447" data-mp="1daa64whgpz98" />}
            <span className="tabular grid h-10 w-10 shrink-0 place-items-center rounded-full bg-tint font-bold text-brand-strong" data-id="element-448" data-mp="2gkoasb32sz69">{i + 1}</span>
            <div className="pt-1.5" data-id="element-449" data-mp="2pejf5gwdilku">
              <p className="text-lg font-bold leading-snug" data-id="element-450" data-mp="2pdhuckpk2kpx">{s.title}</p>
              <p className="mt-1 max-w-[46ch] text-[16px] leading-relaxed text-ink-2" data-id="element-451" data-mp="2ld7kuy2k1c6b">{s.body}</p>
            </div>
          </motion.li>)}
      </ol>
    </motion.div>;
}